import type * as NumericListPromo from '../types/NumericListPromo'
import { imageParser } from '../props/parsers/Image'

export default function numericListPromoComponentParser(
  rawComponent: NumericListPromo.Raw,
): NumericListPromo.Parsed {
  const {
    // contentBackground,
    headlineText,
    image,
    // imageSide,
    imageSize,
    isGradient,
    items,
    kickerText,
  } = rawComponent.numericListPromo

  return {
    name: 'NumericListPromo',
    props: {
      kickerText,
      headlineText,
      textItems: items.map(({ text }) => text),
      imageSize,
      ...imageParser(image),
      isGradient: isGradient === 'true',
    },
  }
}
